export default {
  styleOverrides: {
    root: {
      "&.Mui-error": {
        marginTop: 4,
        marginRight: 4,
        marginLeft: 4,
      },
    },
  },
};
